import styled from 'styled-components';

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const CheckBoxContainer = styled.div`
  margin-top: 10px;
`;

export const RolesErrorLabel = styled.span`
  transition: all 0.3s ease;
  font: inherit;
  color: #f96155;
  margin: 6px 0;
  height: 24px;
  overflow: hidden;
`;
